import { numberRequiredSchema, select2RequiredSchema, statusSchema, stringRequiredSchema } from "utils/validation/validationHelpers";
import { object } from 'yup';

const assignTherapistSchema = object().shape({
    caseload_id: numberRequiredSchema,
    discipline_id: select2RequiredSchema,
    therapist_id: select2RequiredSchema,
    // assessment_date: stringRequiredSchema,
    // meeting_time: stringRequiredSchema
});

export default assignTherapistSchema;